//angular imports
import { ChangeDetectionStrategy, Component } from "@angular/core";

//local imports
import {
  CloseDialogMessage,
  CommandModel,
  Messenger,
} from "@app/shared";
import {
  CategoryDetails,
} from "@app/catalog";

@Component({
  selector: "add-category-form",
  templateUrl: "./add-category-form.component.html",
  styleUrl: "./add-category-form.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddCategoryFormComponent {
  public details = CategoryDetails.empty();


  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public submitCommand = new CommandModel({
    executeAction: () => this.save(),
    isValid: this.details.isValid,
  });

  constructor(
    private messenger: Messenger,
  ) {}

  private save = async () => {
   
  };
}
